import { createSlice } from "@reduxjs/toolkit"

const states = {
    v1: {
        language: 'GB',
    }
}

const initialState = states.v1

export const languageMigration = {
    1: state => state.v1
}

export const languageSlice = createSlice({
    name: "lang",
    initialState,
    reducers: {
        changeLanguage: (state, action) => {
            state.language = action.payload
        },
    },
});

export const { changeLanguage } = languageSlice.actions;

export const selectLanguage = (state) => state.language.language;

export default languageSlice.reducer;